import Marionette from 'backbone.marionette';

/**
 * Base class for views which render in a modal popup window.
 */
export default Marionette.View.extend({

    ui: {
        close: '.close'
    },

    events: {
        'click @ui.close': 'destroy'
    },

    onRender: function () {

        // Center in the window.
        const bounds = this.el.getBoundingClientRect();
        const top = (window.innerHeight - bounds.height) / 2;
        const left = (window.innerWidth - bounds.width) / 2;

        Object.assign(this.el.style, {
            top: `${top}px`,
            left: `${left}px`
        });
    },

    attachElContent: function (html) {
        this.setElement(html);
        this.overlayEl = document.createElement('div');
        this.overlayEl.className = 'overlay';
        document.body.append(this.overlayEl);
        document.body.append(this.el);
    },

    onDestroy: function () {
        this.overlayEl.remove();
    }
});
